import { STRIPE_PUBLISHABLE_KEY } from '../../stripe';

// eslint-disable-next-line no-undef
export const stripe = typeof Stripe === 'function' ? Stripe(STRIPE_PUBLISHABLE_KEY) : null;
export const elements = !!stripe ? stripe.elements() : null;